import React from "react";
import * as Tabs from "@radix-ui/react-tabs";
import CVEditor from "./CVEditor";
import ProfileCoachPanel from "./ProfileCoachPanel";
import LinkedinPlanCoachPanel from "./LinkedinPlanCoachPanel";
import VacaturesCoachPanel from "./VacaturesCoachPanel";
import { MagnifyingGlass, Buildings, IdentificationCard } from "@phosphor-icons/react";
import { SubTabTrigger } from "./CoacheeTabTriggers";

/**
 * "CV en Profielen"-tab van CoacheeDetailPage. Bevat 6 sub-tabs:
 * CV-editor, drie profile-panels (zoekprofiel / werkgever / werknemer),
 * LinkedIn-stappenplan en de Vacatures-zoeker.
 *
 * Alle sub-panels zijn op zichzelf staande componenten die hun eigen
 * data laden — deze panel doet zelf geen netwerk-calls.
 */
export default function CoacheeDocumentsPanel({ coacheeId, coacheeName }) {
  return (
    <Tabs.Root defaultValue="cv">
      <Tabs.List className="flex flex-wrap gap-1 mb-5 bg-zinc-100 p-1 rounded-sm" data-testid="tabs-documents">
        <SubTabTrigger value="cv" testid="subtab-cv">CV</SubTabTrigger>
        <SubTabTrigger value="search-profile" testid="subtab-search-profile">Zoekprofiel</SubTabTrigger>
        <SubTabTrigger value="employer-profile" testid="subtab-employer-profile">Werkgeversprofiel</SubTabTrigger>
        <SubTabTrigger value="employee-profile" testid="subtab-employee-profile">Werknemerprofiel</SubTabTrigger>
        <SubTabTrigger value="linkedin-plan" testid="subtab-linkedin-plan">LinkedIn-plan</SubTabTrigger>
        <SubTabTrigger value="vacatures" testid="subtab-vacatures">Vacatures</SubTabTrigger>
      </Tabs.List>
      <Tabs.Content value="cv">
        <CVEditor coacheeId={coacheeId} readOnly />
      </Tabs.Content>
      <Tabs.Content value="search-profile">
        <ProfileCoachPanel
          coacheeId={coacheeId}
          coacheeName={coacheeName}
          endpoint="search-profile"
          icon={MagnifyingGlass}
          title="Zoekprofiel"
          description={`Read-only weergave van het zoekprofiel van ${coacheeName || "de coachee"} (28 velden in 8 secties).`}
        />
      </Tabs.Content>
      <Tabs.Content value="employer-profile">
        <ProfileCoachPanel
          coacheeId={coacheeId}
          coacheeName={coacheeName}
          endpoint="employer-profile"
          icon={Buildings}
          title="Werkgeversprofiel"
          description={`Hoe ziet de ideale werkgever er voor ${coacheeName || "de coachee"} uit? (read-only)`}
        />
      </Tabs.Content>
      <Tabs.Content value="employee-profile">
        <ProfileCoachPanel
          coacheeId={coacheeId}
          coacheeName={coacheeName}
          endpoint="employee-profile"
          icon={IdentificationCard}
          title="Werknemerprofiel"
          description={`Werk-identiteit, sterke punten en valkuilen van ${coacheeName || "de coachee"} (read-only).`}
        />
      </Tabs.Content>
      <Tabs.Content value="linkedin-plan">
        <LinkedinPlanCoachPanel coacheeId={coacheeId} coacheeName={coacheeName} />
      </Tabs.Content>
      <Tabs.Content value="vacatures">
        <VacaturesCoachPanel coacheeId={coacheeId} coacheeName={coacheeName} />
      </Tabs.Content>
    </Tabs.Root>
  );
}
